import { useCallback, useContext } from 'react';

import { environment } from '../../environment';
import { RedirectContext } from '../../redirect-context';
import { personalizedReturnUrl } from '../utils/personalized-return-url';
import { ThemeHeading } from './theme/theme';
import { Button, Stack } from './ui';

const Step3 = () => {
  const [redirect] = useContext(RedirectContext);

  // Reaching this screen means the academic /interested-trial POST succeeded
  // — step 1 only advances here after the await — so the stamp is written.
  // The marker keeps AuthGate from bouncing the user to /personalize if its
  // read of that stamp is still stale.
  const rerouteUser = useCallback(() => {
    window.location.replace(
      personalizedReturnUrl(redirect || environment.PUBLIC_REACT_APP_URL)
    );
  }, [redirect]);

  const handleStart = () => {
    rerouteUser();
  };

  return (
    <Stack gap="var(--ap-code-gap)" fullWidth>
      <ThemeHeading>
        A member from our Econ team will reach out shortly
      </ThemeHeading>
      <Button onClick={handleStart}>Explore the dashboard</Button>
    </Stack>
  );
};

export default Step3;
